import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Icon as h } from "@tameeni/icons";
import { Button as s } from "@tameeni/ui";
import { HomeSection as p } from "../home-section/home-section.js";
function u({
  sectionSubtitle: n,
  sectionTitle: c,
  contentTitle: a,
  primaryActionLabel: l,
  onPrimaryActionClick: m,
  onSecondaryActionClick: r,
  secondaryActionLabel: i,
  customVector: o,
  children: d
}) {
  return /* @__PURE__ */ e(p, { title: c, subtitle: n, children: /* @__PURE__ */ t("div", { className: "bg-slate-50 rounded-lg relative overflow-hidden", children: [
    /* @__PURE__ */ t("div", { className: "p-14 space-y-4 relative z-20 md:w-3/4", children: [
      /* @__PURE__ */ e("p", { className: "text-h2 lg:text-h1", children: a }),
      /* @__PURE__ */ e("p", { className: "flex flex-col lg: gap-6 text-b1 lg:text-h4 text-slate-600", children: d }),
      (l || i) && /* @__PURE__ */ t("section", { className: "space-x-2", children: [
        /* @__PURE__ */ e(s, { onClick: m, size: "lg", children: l }),
        /* @__PURE__ */ e(s, { onClick: r, size: "md", variant: "text", children: i })
      ] })
    ] }),
    o ? /* @__PURE__ */ e("div", { className: "absolute bottom-0 lg:top-0 end-10 z-10 pe-4", children: o }) : /* @__PURE__ */ e("div", { className: "opacity-30", children: /* @__PURE__ */ e(
      h,
      {
        name: "ShipmentSectionVector",
        className: "absolute bottom-0 lg:top-0 end-10 h-[26.25rem] w-[13.75rem] pe-4 z-10"
      }
    ) })
  ] }) });
}
export {
  u as SingleShipmentSection
};
//# sourceMappingURL=single-shipment-section.js.map
